import { interface___component___has_clickable_action } from "../../interfaces/interface.components";

//	P R O P S

export interface props___ComDigitalMenuDishComponent extends interface___component___has_clickable_action {

	dish_icon: string,
	dish_props: any,

	event___onVisibilityChange: (_: boolean) => void,
	event___onDelete: () => void,

}

//	S T A T E

export interface state___ComDigitalMenuDishComponent {

	dish_active: boolean | undefined,

}

//	S T A T E   D E F A U L T

export const state___ComDigitalMenuDishComponent___default: state___ComDigitalMenuDishComponent = {

	dish_active: undefined,

}